<style lang="less" scoped>
    .margin-tb {
        height: 32px;
        margin-top: 4px;
    }

    // /deep/.el-input__inner {
    //     background: #F8F9FC;
    //     font-size: 12px;
    //     font-weight: 400;
    //     color: #BCBCBC;
    //     line-height: 17px;
    //     font-family: PingFangSC-Regular, PingFang SC;
    //     border-radius: 4px;
    // }
</style>

<template>
    <div class="list-container">
        <div class="list-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="list-content-div">
            <div class="list-header-title-div">运营商管理</div>
            <!-- <div class="page-title-div">电站管理</div> -->
            <ZD-list-querys>
                <template slot="inputs">
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">运营商名称</div>
                        <div class="query-inputs-div flex-1">
                            <el-input size="small" v-model="queryInfo.dealName" placeholder="请输入内容" clearable @keyup.enter.native="getListData(pagination,true)"></el-input>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">注册时间</div>
                        <div class="query-inputs-div flex-1">
                            <el-date-picker v-model="searchTime" :picker-options="pickerOptions" style="width:290px;" type="daterange" size="small" value-format="yyyy-MM-dd" range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleDateChange"></el-date-picker>
                        </div>
                    </div>
                    <div class="list-query-child-div flex">
                        <div class="query-title-div">运营商编号</div>
                        <div class="query-inputs-div flex-1">
                            <el-input size="small" v-model="queryInfo.dealerNo" placeholder="请输入内容" clearable @keyup.enter.native="getListData(pagination,true)"></el-input>
                        </div>
                    </div>
                </template>
                <template slot="actions">
                    <button class="common-bg-button" @click="getListData(pagination,true)">搜 索</button>
                    <button class="common-empty-button" @click="reset()">重 置</button>
                </template>
            </ZD-list-querys>
            <!-- <div class="table-content">
                <div class="page-action-btns flex">
                    <div class="left-title flex-1">
                        运营商列表
                    </div>
                    <div class="right-btn flex-1">
                        <button class="common-bg-button" @click="listAddFun()">新增</button>
                        <button class="common-bg-button" @click="listEditFun()">编辑</button>
                    </div>
                </div>
                <div class="list-table">
                <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData" :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="(sels)=>{selections=sels}" v-on:updateSort="handleSortChange"></ZD-table>
            </div> -->
            <div class="page-action-btns flex">
                <button class="common-bg-button" @click="listAddFun()">新增</button>
                <button class="common-bg-button" @click="listEditFun()">编辑</button>
            </div>
            <!-- 表格 -->
            <div class="list-table">
                <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData" :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="(sels)=>{selections=sels}" v-on:updateSort="handleSortChange"></ZD-table>
            </div>
            <!-- 分页 -->
            <div class="list-pagination">
                <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
            </div>
        </div>
        <!-- 表格 -->
    </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    export default {
        data() {
            return {
                pageConfig: pageConfig, // 页面配置
                tableData: [], // 表格数据
                selections: [], // 表格选项
                pagination: pageConfig.pagination,
                queryInfo: { //初始化对象,包含搜索页签
                    sortType: 0
                },
                operates: {
                    width: 100,
                    fixed: "right",
                    list: [{
                        id: "report",
                        label: "报表",
                        type: "primary",
                        show: true,
                        disabled: false,
                        method: (index, row) => {
                            this.$store.commit('setEditId', row.dealNo)
                            // this.$router.push({
                            //     name: pageConfig.reportRouter
                            // });
                            window.open(this.$router.resolve({ name: pageConfig.reportRouter }).href, '_blank')
                        }
                    }, ]
                }, // 列操作按钮
                searchTime: [], //选择时间
                pickerOptions: { //修改el-date-picker的时间
                    disabledDate(time) {
                        return time.getTime() > Date.now()
                    }
                },
            }
        },
        methods: {
            init() {
                this.getListData(this.pagination, true);
            },
            // 获取表格数据
            getListData(pagination, reload = false) {
                let _ = this;
                _.$U.showLoading(_);
                _.queryInfo.pageNum = pagination.current - 1;
                if (reload) {
                    this.pagination.current = 1;
                    _.queryInfo.pageNum = 0;
                }
                _.queryInfo.pageSize = pagination.pageSize;
                _.queryInfo.corpNo = _.$store.state.corpNo;
                _.$H.post(_, _.$A.dealer.list, _.queryInfo).then(res => {
                    _.tableData = res.data.data.content || [];
                    _.pagination.total = res.data.data.totalElements || 0;
                    _.$U.hideLoading(_);
                })
            },
            //选择结束时间
            handleDateChange(val) {
                if (val) {
                    this.queryInfo.dtFrom = val[0];
                    this.queryInfo.dtTo = val[1];
                } else {
                    delete this.queryInfo.dtFrom;
                    delete this.queryInfo.dtTo;
                }
            },
            //排序
            handleSortChange(val) {
                let _ = this;
                if (val.prop == 'stationNumber') {
                    if (val.order == 'ascending') {
                        _.queryInfo.sortType = -1;
                    } else {
                        _.queryInfo.sortType = 1;
                    }
                } else if (val.prop == 'pileNumber') {
                    if (val.order == 'ascending') {
                        _.queryInfo.sortType = -2;
                    } else {
                        _.queryInfo.sortType = 2;
                    }
                } else if (val.prop == 'repairNumber') {
                    if (val.order == 'ascending') {
                        _.queryInfo.sortType = -3;
                    } else {
                        _.queryInfo.sortType = 3;
                    }
                } else if (val.prop == 'totalChargeCount') {
                    if (val.order == 'ascending') {
                        _.queryInfo.sortType = -4;
                    } else {
                        _.queryInfo.sortType = 4;
                    }
                } else if (val.prop == 'orderNumber') {
                    if (val.order == 'ascending') {
                        _.queryInfo.sortType = -5;
                    } else {
                        _.queryInfo.sortType = 5;
                    }
                } else if (val.prop == 'userNumber') {
                    if (val.order == 'ascending') {
                        _.queryInfo.sortType = -6;
                    } else {
                        _.queryInfo.sortType = 6;
                    }
                } else if (val.prop == 'totalFee') {
                    if (val.order == 'ascending') {
                        _.queryInfo.sortType = -7;
                    } else {
                        _.queryInfo.sortType = 7;
                    }
                }
                _.getListData(_.pagination, true);
            },
            // 页面新增方法
            listAddFun() {
                this.$S.listAddFun(this, pageConfig.tableEditObj);
            },
            // 页面编辑方法
            listEditFun() {
                this.$S.tableEditFun(this, this.selections, pageConfig.tableEditObj);
            },
            //重置
            reset() {
                this.queryInfo.sortType = 0;
                this.pagination.current = 1;
                delete this.queryInfo.dealName;
                delete this.queryInfo.dealNo;
                delete this.queryInfo.mobile;
                delete this.queryInfo.dtFrom;
                delete this.queryInfo.dtTo;
                delete this.queryInfo.custType;
                delete this.queryInfo.dealerNo;
                this.searchTime = [];
                this.getListData(this.pagination, true);
            }
        },
        mounted() {
            this.init();
        }
    }
</script>